var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 4V28H1.33337V4H30.6667ZM28 6.66667H4.00004V12H28V6.66667ZM28 14.6667H25.3334V23.688L20.6667 20.888L16 23.688V14.6667H4.00004V25.3333H28V14.6667ZM22.6667 14.6667H18.6667V18.9787L20.6667 17.7787L22.6667 18.9787V14.6667Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipLight);
export default __webpack_public_path__ + "static/media/membership-light.f3ede6527f16141a9fc62a13ec0b1fbb.svg";
export { ForwardRef as ReactComponent };